import * as actions from "../actions/"
import {toast} from "react-toastify"

const defaultState = {
  fetching: false,
  fetched: false,
  error: null,
  data: {}
}

export default function reducer(state = defaultState, action) {

  switch (action.type) {
    case actions.SETTINGS_FETCH.PENDING: {
      return {...state, fetching:true}
    }
    case actions.SETTINGS_FETCH.ERROR: {
      return {...state, fetching: false, error: action.payload}
    }
    case actions.SETTINGS_FETCH.SUCCESS: {
      return {...state, fetching: false, fetched: true, data: action.payload}
    }
  }

  return state
}


// WEBPACK FOOTER //
// ./src/reducers/settingsReducer.js